import BaseRadioButton from 'shared/components/base/form/base-radio-button'

type Props = {
  value?: string
  onChange?: (newValue?: string) => any
  teams?: string[]
  label?: string
}

const BussinessFilter = ({ value, onChange, teams, label }: Props) => {
  return (
    <>
      <div className="mb-4 font-medium text-3.5 leading-[30px] text-[#0086B3]">
        {label || 'بخش های سازمانی'}{' '}
      </div>
      <div className="grid grid-cols-2 items-center mb-0.5  ">
        {teams
          ? teams.map((bu) => (
              <div
                className="flex items-center pl-4 mb-4 cursor-pointer"
                key={bu}
                onClick={() => {
                  if (typeof onChange === 'function') onChange(bu)
                }}
              >
                <BaseRadioButton className="ml-2" checked={bu === value} />
                <p className="inline text-sm font-normal leading-8 text-color-title">
                  {bu}
                </p>
              </div>
            ))
          : null}
      </div>
    </>
  )
}

export default BussinessFilter
